import React, { useRef, useState } from 'react';
import { Desktop, Mobile } from '../../../App';
import { USDT, formatUSDNoDecimals } from '../../../helpers/helperFunctions';
import { H3, H4, H5, P1, P2, P3 } from '../../../styles/FontStyles';
import { Flexed } from '../../../styles/GlobalComponents';
import { color, colors } from '../../../styles/GlobalStyles';
import { HubImage, HubStyled } from './EarnBetHub.styled';

import image from '../../../assets/images/backoffice/earnBet/EarnBetHub.png';

export const EarnBetHub = ({ price }: any) => {
  return (
    <div>
      <P1 bold mb={'20'}>
        Checkout:
      </P1>
      <HubStyled>
        <div>
          <HubImage image={image} />
          <Flexed column between>
            <div>
              <Desktop>
                <H3 mb='4'>Deposit Amount</H3>
              </Desktop>
              <Mobile>
                <H5 mb='4' mr='20'>
                  Deposit Amount
                </H5>
              </Mobile>
              <P2 mb='12' color={colors.neutral500}>
                {formatUSDNoDecimals(price)} {USDT}{' '}
              </P2>
            </div>
          </Flexed>
        </div>
      </HubStyled>
    </div>
  );
};
